import { includes, toLower } from "lodash";

export const getVisibleCourses = (courses, query) => {
    if (!query) return courses;
    return courses.filter(course => 
        includes(toLower(course.name), toLower(query)) ||
        includes(toLower(course.shortName), toLower(query))
    )
}